import { __assign } from 'tslib';
import ReactTable from 'react-table';

var useExpandedv2 = function (hooks) {
    hooks.stateReducers.push(reducer);
};
// Reducer
function reducer(state, action) {
    var _a;
    if (action.type === ReactTable.actions.toggleRowExpanded) {
        var id = action.id;
        var exists = state.expanded[id];
        if (exists && Object.entries(state.expanded).length > 1) {
            return __assign(__assign({}, state), { expanded: (_a = {},
                    _a[id] = true,
                    _a) });
        }
        return state;
    }
}

export { useExpandedv2 };
//# sourceMappingURL=useExpandedv2.js.map
